<template>
    <div id="dashboard" :class="(propecInformation && propecInformation.length == 0) && isMobile?'hide-info-propec':''">
    <main-layout :account-blocked-message="accountBlockedMessage">
        <Billboard target="POP_UP" @finish="handleDismissibleBannersFinished"></Billboard>

        <template v-slot:desktop-optional="{ alone }" v-if="showInfoMobile">
            <app-card
                :height="`${alone ? '100%' : 'auto'}`"
                style="padding-bottom: 12px !important"
                :contentStyle="`height: ${!alone ? '160px!important;' : 'auto'}`"
                contentIsScrollable="true"
                :class="{ 'mt-6 pb-1 ': !alone, 'solo-propec-info-container': alone }"
                class="shepherd-dashboard-propec-info"
                v-if="propecInformation && propecInformation.length > 0"
            >
                <template v-slot:title>
                    <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1" data-cy="card-title-info-propec">
                        <span class="sidebar-title-info-propec">{{ $t('dashboard.propecInfo') }}</span>

                        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" class="appbar-icon-button btn-bg-color-blue dark-blue-color mr-0" style="cursor: pointer" data-cy="open-dialog-all-info-propec" @click="isInfoPropecDialogOpen = true"> mdi-arrow-expand </v-icon>
                            </template>

                            <span class="font-size-md">{{ $t('dashboard.showAll') }}</span>
                        </v-tooltip>
                    </v-card-title>
                </template>

                <template v-slot:content>
                    <propec-information-list id="smallList" limit="5" :propecInformation="propecInformation" data-cy="propec-information-list"> </propec-information-list>

                    <app-dialog :isPropecInfoDetails="true" :value="isInfoPropecDialogOpen" @input="isInfoPropecDialogOpen = $event" :title="$t('dashboard.propecInfo')" width="70vh">
                        <template v-slot:content>
                            <propec-information-list id="bigList" :propecInformation="propecInformation" :contentIsScrollable="true" :closeInfoPropecDialog="true" data-cy="app-dialog-propec-information-list"> </propec-information-list>
                        </template>

                        <template v-slot:buttons="{}">
                            <v-btn text outlined class="myprovet-btn-cancel" @click="isInfoPropecDialogOpen = false" data-cy="app-dialog-info-propec-close-btn"> {{ $t('common.close') }} </v-btn>
                        </template>
                    </app-dialog>

                    <app-dialog
                        :isPropecInfoDetails="true"
                        :value="isDetailedInfoPropecDialogOpen"
                        @input="isDetailedInfoPropecDialogOpen = $event"
                        :title="objInfoPropec.title"
                        :subtitle="objInfoPropec.created_at"
                        data-cy="app-dialog-info-propec-detail"
                        contentStyle="height: auto; max-height: 70vh; overflow-y: scroll;"
                        width="50vw"
                    >
                        <template v-slot:content>
                            <propec-info-details-dialog :visible="isDetailedInfoPropecDialogOpen" :individualPropecInfo="objInfoPropec"></propec-info-details-dialog>
                        </template>

                        <template v-slot:buttons="{}">
                            <v-spacer></v-spacer>
                            <v-btn text class="myprovet-btn-ok" @click="onClickOkDetailedPropecInformation()" data-cy="app-dialog-info-propec-detail-ok-btn"> OK </v-btn>
                        </template>
                    </app-dialog>
                </template>
            </app-card>
        </template>

        <v-row class="d-flex align-start full-height row-content">
            <v-col cols="7" :class="showInfoMobile?'full-height ml-height':'middle-height'" id="shortcuts">
                <app-card class="full-height d-flex flex-column align-stretch shepherd-dashboard-shortcuts" contentStyle="flex: 1; display: flex; padding-top: 0; padding-bottom: 0;">
                    <template v-slot:title>
                        <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1">
                            {{ $t('dashboard.customShortcuts') }}
                            <v-spacer></v-spacer>

                            <div class="d-flex justify-end">
                                <v-icon class="appbar-icon-button btn-bg-color-blue dark-blue-color mr-0 shepherd-dashboard-shortcuts-button" style="cursor: pointer" data-cy="cog-open-dialog-shortcut" @click="isCustomShortcutsDialogOpen = true"> mdi-cog-outline </v-icon>
                            </div>
                        </v-card-title>
                    </template>

                    <template v-slot:content>
                        <app-dialog :value="isCustomShortcutsDialogOpen" @input="isCustomShortcutsDialogOpen = $event" :width="getCustomShortcutsDialogWidth" :title="$t('dashboard.customShortcuts')" data-cy="app-dialog">
                            <template v-if="selected_layout == 0" v-slot:dialog-button="slotProps">
                                <div class="d-flex flex-column justify-center align-center custom-shorcuts-div" style="cursor: pointer" v-bind="slotProps.event.attrs" v-on="slotProps.event.on" data-cy="content-open-dialog-shortcut">
                                    <v-icon class="appbar-icon-button btn-bg-color-blue light-blue-color">mdi-plus-circle</v-icon>
                                    <p class="font-size-lg dark-blue-color mt-4" style="max-width: 50%; text-align: center; font-size: 16px">{{ $t('dashboard.createFirstShortcut') }}</p>
                                </div>
                            </template>

                            <template v-slot:content>
                                <app-custom-shortcuts-form
                                    :user_custom_shortcuts_layout="user_custom_shortcuts_layout"
                                    :config_custom_shortcuts="config_custom_shortcuts"
                                    :pickedLayout="formCustomShortcuts.pickedLayout"
                                    :selectedCustomShortcuts="formCustomShortcuts.selectedCustomShortcuts"
                                    data-cy="app-custom-shortcuts-form"
                                ></app-custom-shortcuts-form>
                            </template>

                            <template v-slot:buttons="{}">
                                <v-row>
                                    <v-col cols="12" md="6" sm="6">
                                        <v-btn text outlined class="myprovet-btn-cancel" @click="isCustomShortcutsDialogOpen = false" data-cy="app-dialog-cancel-btn"> {{ $t('common.cancel') }} </v-btn>
                                    </v-col>

                                    <v-col cols="12" md="6" sm="6">
                                        <v-btn text class="myprovet-btn-ok" @click="onSubmitCustomShortcuts" data-cy="app-dialog-submit-btn"> Ok </v-btn>
                                    </v-col>
                                </v-row>
                            </template>
                        </app-dialog>

                        <app-custom-shortcuts-display :selected_layout="selected_layout" :number_of_cards="number_of_cards" :userCustomShortcuts="userCustomShortcuts"></app-custom-shortcuts-display>
                    </template>
                </app-card>
               <app-card v-if="!showInfoMobile && propecInformation && propecInformation.length > 0"
                    :height="'auto'"
                    style="padding-bottom: 12px !important"
                    :contentStyle="`height:'160px!important;'`"
                    contentIsScrollable="true"
                    :class="'mt-6 pb-1'"
                    class="shepherd-dashboard-propec-info"

                >
                    <template v-slot:title>
                        <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1" data-cy="card-title-info-propec">
                            <span class="sidebar-title-info-propec">{{ $t('dashboard.propecInfo') }}</span>

                            <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="appbar-icon-button btn-bg-color-blue dark-blue-color mr-0" style="cursor: pointer" data-cy="open-dialog-all-info-propec" @click="isInfoPropecDialogOpen = true"> mdi-arrow-expand </v-icon>
                                </template>

                                <span class="font-size-md">{{ $t('dashboard.showAll') }}</span>
                            </v-tooltip>
                        </v-card-title>
                    </template>

                    <template v-slot:content>
                        <propec-information-list id="smallList" limit="3" :propecInformation="propecInformation" data-cy="propec-information-list"> </propec-information-list>

                        <app-dialog :isPropecInfoDetails="true"  :value="isInfoPropecDialogOpen" @input="isInfoPropecDialogOpen = $event" :title="$t('dashboard.propecInfo')" width="70vh">
                            <template v-slot:content>
                                <propec-information-list id="bigList" :propecInformation="propecInformation" :contentIsScrollable="true" :closeInfoPropecDialog="true" data-cy="app-dialog-propec-information-list"> </propec-information-list>
                            </template>

                            <template v-slot:buttons="{}">
                                <v-btn text outlined class="myprovet-btn-cancel" @click="isInfoPropecDialogOpen = false" data-cy="app-dialog-info-propec-close-btn"> {{ $t('common.close') }} </v-btn>
                            </template>
                        </app-dialog>

                        <app-dialog
                            :isPropecInfoDetails="true"
                            :value="isDetailedInfoPropecDialogOpen"
                            @input="isDetailedInfoPropecDialogOpen = $event"
                            :title="objInfoPropec.title"
                            :subtitle="objInfoPropec.created_at"
                            data-cy="app-dialog-info-propec-detail"
                            contentStyle="height: auto; max-height: 70vh; overflow-y: scroll;"
                            width="50vw"
                        >
                            <template v-slot:content>
                                <propec-info-details-dialog :visible="isDetailedInfoPropecDialogOpen" :individualPropecInfo="objInfoPropec"></propec-info-details-dialog>
                            </template>
                            <template v-slot:buttons="{}">
                                <v-spacer></v-spacer>
                                <v-btn text class="myprovet-btn-ok" @click="onClickOkDetailedPropecInformation()" data-cy="app-dialog-info-propec-detail-ok-btn"> OK </v-btn>
                            </template>
                        </app-dialog>
                    </template>
                </app-card>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0" v-if="isMobile">
                <app-card
                    :height="'auto'"
                    :contentStyle="`height:'160px!important;'`"
                    contentIsScrollable="true"
                    :class="'mt-2 pb-0 pt-0 elevation-0'"
                    class="shepherd-dashboard-propec-info info-mobile"

                >
                    <template v-slot:title>
                        <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1" data-cy="card-title-info-propec">
                            <span class="sidebar-title-info-propec">{{ $t('dashboard.shortcuts') }}</span>
                        </v-card-title>
                    </template>

                </app-card>
                    <app-custom-shortcuts-display :selected_layout="4" :number_of_cards="number_of_cards" :userCustomShortcuts="userCustomShortcuts"></app-custom-shortcuts-display>
                </v-col>
                <v-col cols="5" :class="isMobile?'shepherd-dashboard-campaigns pb-0 pt-0':'full-height shepherd-dashboard-campaigns'">
                    <Billboard target="DASHBOARD_RIGHT" />
               </v-col>
               <v-col cols="12 pt-0 pb-0 mt-0" v-if="isMobile">
                <app-card v-if="propecInformation && propecInformation.length>0"
                    :height="'auto'"
                    :contentStyle="`height:'160px!important;'`"
                    contentIsScrollable="true"
                    :class="'pb-0 pt-0 pb-0 mt-0 elevation-0'"
                    class="shepherd-dashboard-propec-info info-mobile"

                >
                    <template v-slot:title>
                        <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1" data-cy="card-title-info-propec">
                            <span class="sidebar-title-info-propec">{{ $t('dashboard.propecInfo') }}</span>
                        </v-card-title>
                    </template>
                </app-card>
                <propec-information-list id="smallList" limit="3" :propecInformation="propecInformation" data-cy="propec-information-list"> </propec-information-list>
                </v-col>
        </v-row>

        <confirmation-dialog :value="isPendingCartDialogOpen" @onSuccess="goToShoppingCart(true)" @onCancel="goToShoppingCart(false)" :title="$t('dashboard.cartTitle')" :question="$t('dashboard.cartQuestion')" :cancelText="$t('common.no')" :confirmText="$t('common.yes')">
        </confirmation-dialog>
    </main-layout>
</div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useBannersStore } from '@/Stores/banners';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { axios } from '@/Services/Backend';
import MainLayout from '../Layouts/MainLayout';
import shepherdTour from '../Shepherd/dashboard.js';
import { slider, slideritem } from 'vue-concise-slider'
import { useAppStore } from '@/Stores/app.js';


export default {
    components: {
        MainLayout,
        slider,
        slideritem
    },

    props: ['user_custom_shortcuts_layout', 'config_custom_shortcuts', 'selected_layout', 'selected_custom_shortcuts', 'number_of_cards', 'userCustomShortcuts', 'propecInformation', 'accountBlockedMessage'],

    data: () => ({
        isInfoPropecDialogOpen: false,
        isToReopenInfoPropecDialogOpen: false,
        isDetailedInfoPropecDialogOpen: false,

        isCustomShortcutsDialogOpen: false,

        isPendingCartDialogOpen: false,

        formCustomShortcuts: {
            pickedLayout: null,
            selectedCustomShortcuts: [],
            numberOfCards: null,
        },

        showInfoMobile:true,

        objInfoPropec: {
            created_at: '',
            title: '',
            preview: '',
            description: '',
        },
        options: {
          currentPage: 0,
          slidesToScroll: 2,
        },
        styleCss:{'width': '47%','margin-right': '2%'}
    }),

    computed: {
        ...mapStores(useUserStore, useBannersStore, useBranchStore, useNormalOrderStore, useAppStore),

        getCustomShortcutsDialogWidth() {
            return this.getResponsiveDialogWidth('65vw', '40vw');
        },
        isMobile(){
            return this.appStore.is_mobile
        }

    },

    mounted() {
        this.formCustomShortcuts.pickedLayout = this.selected_layout;
        this.formCustomShortcuts.selectedCustomShortcuts = this.selected_custom_shortcuts;
        this.formCustomShortcuts.numberOfCards = this.number_of_cards;

        window.EventBus.$on('on-change-picked-layout', (pickedLayout, numberOfCards) => {
            this.onChangePickedLayout(pickedLayout, numberOfCards);
        });

        window.EventBus.$on('on-change-custom-shortcuts-checkboxes', (checkboxItems) => {
            this.onChangeCustomShortcutsCheckboxes(checkboxItems);
        });

        window.EventBus.$on('onOpenDetailedPropecInformationDialog', (obj_propec_information, closeInfoPropecDialog) => {
            this.onOpenDetailedPropecInformationDialog(obj_propec_information, closeInfoPropecDialog);
        });

        window.EventBus.$on('start-tutorial', () => {
            this.showTutorial(true);
        });

        let portrait = window.matchMedia("(orientation: portrait)");
        //console.log('portrait',portrait)

        this.showInfoMobile=this.isMobile?false:!portrait.matches

        portrait.addEventListener("change", (e)=> {
             //console.log('in',e,window.innerWidth)
            if(e.matches) {
                // Portrait mode
                this.showInfoMobile=window.innerWidth<=1024?false:true
            } else {
                // Landscape
                this.showInfoMobile=window.innerWidth<=1024?false:true
            }
        })
    },

    beforeDestroy() {
        shepherdTour.cancel();
        window.EventBus.$off('on-change-picked-layout');
        window.EventBus.$off('on-change-custom-shortcuts-checkboxes');
        window.EventBus.$off('onOpenDetailedPropecInformationDialog');
        window.EventBus.$off('start-tutorial');
    },

    methods: {
        goToShoppingCart(changePage) {
            this.isPendingCartDialogOpen = false;

            if (changePage) {
                this.$inertia.visit(`/orders/normal/cart/${this.branchStore.branch?.client_number}/${this.branchStore.branch?.company_branch}`);
            } else {
                this.showTutorial();
            }
        },

        handleDismissibleBannersFinished() {
            this.bannersStore.setShowPopupBillboards(false);

            if (this.userStore.isFreshLogin && this.normalOrderStore.getProductCount > 0) {
                this.isPendingCartDialogOpen = true;
            } else {
                if (!this.isPendingCartDialogOpen) this.showTutorial();
            }

            this.userStore.setInactiveFreshLogin();
        },

        showTutorial(forced) {
            if (forced) {
                window.EventBus.$emit('add-tutorial-overlay');
                shepherdTour.start();
            } else {
                axios
                    .get('/api/tutorials/dashboard')
                    .then((response) => {
                        if (!response.data.viewed) {
                            // Fix an edge case where tutorials might still show when changing pages at a very specific moment
                            if (this.$page.url == '/dashboard') {
                                if(!this.isMobile){
                                    window.EventBus.$emit('add-tutorial-overlay');
                                    shepherdTour.start();
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        },

        onChangePickedLayout(pickedLayout, numberOfCards) {
            this.formCustomShortcuts.pickedLayout = pickedLayout;
            this.formCustomShortcuts.numberOfCards = numberOfCards;
        },

        onChangeCustomShortcutsCheckboxes(checkboxItems) {
            this.formCustomShortcuts.selectedCustomShortcuts = checkboxItems;
        },

        onSubmitCustomShortcuts() {
            this.loading = true;

            this.$inertia.post('/api/store-custom-shortcuts', this.formCustomShortcuts, {
                onSuccess: (response) => {
                    this.loading = false;

                    if (response.props.error) {
                        this.showError(response.props.message);
                    } else {
                        this.isCustomShortcutsDialogOpen = false;

                        this.showSuccess(response.props.message);
                    }
                },
                onError: (errors) => {
                    this.loading = false;

                    for (const [key, value] of Object.entries(errors)) {
                        if (key == 'pickedLayout' || key == 'selectedCustomShortcuts') {
                            this.showError(value);
                        }
                    }
                },
            });
        },

        onOpenDetailedPropecInformationDialog(obj_propec_information, closeInfoPropecDialog) {
            if (closeInfoPropecDialog) {
                this.isInfoPropecDialogOpen = false;
                this.isToReopenInfoPropecDialogOpen = true;
            }

            this.objInfoPropec = obj_propec_information;
            this.isDetailedInfoPropecDialogOpen = true;
        },

        onClickOkDetailedPropecInformation() {
            this.isDetailedInfoPropecDialogOpen = false;

            if (this.isToReopenInfoPropecDialogOpen) {
                this.isToReopenInfoPropecDialogOpen = false;
                this.isInfoPropecDialogOpen = true;
            }
        },
    },
};
</script>

<style scoped>
.custom-shorcuts-div {
    width: 100%;
    margin-bottom: 16px;
    box-sizing: border-box;

    /*
     * Sadly native CSS doesn't have the ability to control the dashed border spacing/stroke size.
     *
     * So we can use tools like: https://kovart.github.io/dashed-border-generator/ to generate an SVG which draws the border.
     * (parameters: width: 590, height: 695, stroke width: 4, dash array: 10, dash offset: 4, offset: butt)
    **/
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%230D8CCDFF' stroke-width='4' stroke-dasharray='12' stroke-dashoffset='4' stroke-linecap='butt'/%3e%3c/svg%3e");
    border-radius: 16px;
}

@media only screen and (max-width: 1550px) {
    .sidebar-title-info-propec {
        max-width: min-content;
    }
}
</style>
